import type { IntlShape } from "react-intl";
import type { FundingApplicationSchemas } from "api-types";

import { MESSAGES } from "./message-definitions";

type RequiredDocumentType = "susa" | "pool-bancario" | "cash-flow-forecast";

const DOCUMENT_ACTION_MESSAGES: Record<RequiredDocumentType, (typeof MESSAGES)[keyof typeof MESSAGES]> = {
  susa: MESSAGES.nextActionSusa,
  "pool-bancario": MESSAGES.nextActionPoolBancario,
  "cash-flow-forecast": MESSAGES.nextActionCashFlow,
};

export function buildConnectionsSubtitle(
  stages: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen,
  intl: IntlShape
): string {
  const actions: string[] = [];

  if (stages.banking) {
    actions.push(intl.formatMessage(MESSAGES.nextActionBanking));
  }

  if (stages.documents) {
    for (const doc of stages.documents) {
      const message = DOCUMENT_ACTION_MESSAGES[doc.documentType as RequiredDocumentType];
      if (message) {
        actions.push(intl.formatMessage(message));
      }
    }
  }

  if (stages.creditConsent) {
    actions.push(intl.formatMessage(MESSAGES.nextActionCreditCheck));
  }

  if (actions.length === 0) {
    return intl.formatMessage(MESSAGES.connectionsSubtitleNoActions);
  }

  const listFormatter = new Intl.ListFormat(intl.locale, { style: "long", type: "conjunction" });
  const nextActions = listFormatter.format(actions);

  return intl.formatMessage(MESSAGES.connectionsSubtitleWithActions, { nextActions });
}
